import React from 'react';
import { Link } from 'react-router-dom'
const TiTroviIn = ({ children, title, index }) => {
    return (<>
        <p className="breadcrumb-title">You are in:</p>
        <ol className="breadcrumb">
            {children.map(({ to, label }) => (
                <li key={to + index} className="breadcrumb-item">
                    <Link key={to} to={to}>{label}</Link>
                </li>
            ))}
            <li key={index} className="breadcrumb-item"><strong>{title}</strong></li>
        </ol>
    </>
    )
}
export default TiTroviIn